import type { Percentage, Point } from "@pdfking/math"
import type { ScaleEnum } from "./ScaleEnum"

export type Scale =
  | Percentage
  | Point<Percentage>
  | ScaleEnum
  | string
  | undefined
